<template>
  <div class="member-search">
    <el-select v-model="value" filterable @change="changeSearchKey">
      <el-option
        v-for="item in searchableInfos"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>
    <el-input
      class="right"
      clearable
      v-if="['name', 'telephone'].includes(value)"
      v-model="searchInfo.searchText"
      @input="searchData"
    ></el-input>
    <el-select
      class="right"
      v-else-if="value === 'status'"
      v-model="searchInfo.searchText"
      key="status"
      filterable
      clearable
      placeholder="请选择"
      style="width: 100%"
      @input="searchData"
    >
      <el-option v-for="item in status" :key="item" :label="item" :value="item"></el-option>
    </el-select>
    <el-select
      class="right"
      v-else-if="value === 'companyRoleName'"
      v-model="searchInfo.searchArray"
      key="role"
      filterable
      clearable
      multiple
      collapse-tags
      placeholder="请选择"
      style="width: 100%"
      @input="searchData"
    >
      <el-option
        v-for="item in roles"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      ></el-option>
    </el-select>
    <div class="icon-search-box" @click="searchData">
      <i class="el-icon-search"></i>
    </div>
  </div>
</template>
<script>
import { searchableInfos, status } from "@/views/Company/Manage/User/CompanyUser/DptMember/static"
export default {
  name: "member-search",
  props: { searchInfos: Array },
  inject: ["roles"],
  data() {
    return {
      searchableInfos,
      status,
      value: "name",
      searchInfo: {
        searchText: "",
        searchArray: []
      },
      filterKey: "name"
    }
  },
  methods: {
    searchInactive() {
      this.value = "status"
      this.filterKey = "status"
      this.searchInfo.searchText = "未激活"
      this.searchData()
    },
    changeSearchKey(key) {
      this.filterKey = key
      this.searchInfo.searchArray = []
      this.searchInfo.searchText = ""
    },
    searchData() {
      this.$emit("search", this.searchInfo, this.filterKey)
    }
  }
}
</script>

<style lang="scss" scoped>
.member-search {
  display: flex;
  width: 360px;
  ::v-deep {
    .el-select {
      width: 200px;
      .el-input.is-focus .el-input__inner {
        border-color: #dcdfe6;
      }
      .el-input__inner {
        border-radius: 4px 0 0 4px;
        border-right: none;
        &:hover,
        &:focus {
          border-color: #dcdfe6;
        }
      }
    }
  }
  .icon-search-box {
    @include flex-center;
    background-color: #f5f7fa;
    color: #909399;
    border: 1px solid #dcdfe6;
    border-left: none;
    border-radius: 0 4px 4px 0;
    padding: 0 12px;
    font-size: 14px;
    cursor: pointer;
  }
  .right {
    ::v-deep {
      .el-input__inner {
        border-radius: unset !important;
      }
      .el-popover__reference-wrapper {
        width: 100%;
        .user-scope-selector-container {
          border-radius: unset !important;
          .value-wrapper {
            min-height: 30px;
          }
        }
      }
    }
  }
}
</style>
